import React from 'react';
import { Layout } from '../components/Layout';
import { FinanceOverview } from '../components/Business/FinanceOverview';
import { RevenueGoals } from '../components/Business/RevenueGoals';

export function Business() {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Business Dashboard</h1>
        </div>

        {/* Widgets Grid */}
        <div className="grid grid-cols-1 gap-6">
          <FinanceOverview />
          <RevenueGoals />
        </div>
      </div>
    </Layout>
  );
}